export const processDate = (date: string) => {
  const separator = /\.|\/|\s/g;
  const [month, day, year] = new Date(date)
    .toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    })
    .split(separator);
  return `${month} ${day} ${year}`;
};

export const getReadTime = (content: string) => {
  const wordsPerMinute = 240;
  const textLength = content?.split(' ').length;
  const readingTimeMinutes = Math.ceil(textLength / wordsPerMinute);
  const roundedTime = Math.ceil(readingTimeMinutes / 5) * 5;

  return roundedTime;
};